import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { VaLink } from '@department-of-veterans-affairs/component-library/dist/react-bindings';
import {
  VRE_FACT_SHEET_URL,
  YOUTUBE_ORIENTATION_VIDEO_URL,
} from '../constants';

const supportAndServicesCard = {
  title: 'Review the VR&E support-and-service tracks video on YouTube',
  body: 'A VR&E counselor will guide you through your options and help you achieve your goals for employment or independent living.',
  href: YOUTUBE_ORIENTATION_VIDEO_URL,
  external: true,
};

const factSheetCard = {
  title: 'Download the VR&E information sheet',
  body: 'The VR&E program helps transitioning Service members and Veterans with service-connected disabilities prepare for, obtain, and maintain suitable employment.',
  href: VRE_FACT_SHEET_URL,
  filetype: 'PDF',
  download: true,
};

const careerPlanningBody =
  'Check out our career resources and tools to help you achieve your employment goals. You can assess your career interests and learn about career paths.';

const getCareerPlanningCard = step => {
  const body = [1, 2, 3, 4].includes(step)
    ? [
        `${careerPlanningBody} These career resources will help you prepare for your initial evaluation counselor meeting.`,
      ]
    : [careerPlanningBody];

  return {
    title: 'Explore career planning tools and resources',
    body,
    href: `${window.location.origin}/careers-employment/track-your-vre-benefits/vre-benefit-status/career-planning`,
  };
};

const getCardsForStep = step => {
  const careerPlanningCard = getCareerPlanningCard(step);
  return [factSheetCard, supportAndServicesCard, careerPlanningCard];
};

const HubCardList = ({ step }) => {
  const history = useHistory();
  const cards = getCardsForStep(step);

  if (!cards.length) return null;

  const handleRouteChange = (event, href) => {
    event.preventDefault();
    history.push(href);
  };

  return (
    <div className="vads-u-margin-top--4 vads-u-margin-bottom--2">
      <h3 className="va-nav-linkslist-heading">Explore VR&E resources</h3>

      <div>
        {cards.map(card => (
          <div
            key={card.title}
            className="vads-u-margin-top--2 vads-u-padding-bottom--2"
          >
            <div className="vads-u-font-weight--bold">
              {card.useRouter ? (
                <VaLink
                  href={card.href}
                  text={card.title}
                  filetype={card.filetype}
                  onClick={event => handleRouteChange(event, card.href)}
                  external={card.external}
                  download={card.download}
                />
              ) : (
                <VaLink
                  download={card.download}
                  href={card.href}
                  text={card.title}
                  filetype={card.filetype}
                  external={card.external}
                />
              )}
            </div>

            {Array.isArray(card.body) ? (
              card.body.map((text, i) => (
                <p
                  key={i}
                  className={
                    i === 0
                      ? 'vads-u-margin-top--1 vads-u-margin-bottom--1'
                      : 'vads-u-margin-top--1 vads-u-margin-bottom--0'
                  }
                >
                  {text}
                </p>
              ))
            ) : (
              <p className="vads-u-margin-top--1 vads-u-margin-bottom--0">
                {card.body}
              </p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

HubCardList.propTypes = {
  step: PropTypes.number.isRequired,
};

export default HubCardList;
